import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faCog, faSearch, faPlus } from '@fortawesome/free-solid-svg-icons';
import { Col, Row, Form, Button, ButtonGroup, InputGroup, Dropdown,Card } from '@themesberg/react-bootstrap';
import Preloader from "../components/Preloader"; // Path to your code above
import { VehiclesTable } from "../../src/components/Tables";
import { use } from "react";
import { useState, useEffect } from "react";
import { getDriverDetails, getDriversList, setDriverSearch, getVehiclesList } from "../api/services/";

import TmsPopup from "../../src/components/Popup"; // Path to your code above
import DriverAddFrom from "../pages/forms/DriverAddForm"
import { Routes } from "../routes";
import { useHistory } from "react-router-dom";
// import { Col, Row, Card, Badge, Container } from '@themesberg/react-bootstrap';



export default () => {
  const [vehicles, setVehicles] = useState({});
  const [search, setSearch] = useState("");
  const [pageSize, setPageSize] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);

  const [searchInput, setSearchInput] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showDriverAddWindow, setShowDriverAddWindow] = useState(false);
  const [filterType, setFilterType] = useState("ALL");


  const history = useHistory();
  // 🔹 Fetch vehicles (TABLE)
  const fetchVehicles = async (
    page = 1,
    searchValue = search,
    filter = filterType   // 👈 ADD THIS
  ) => {
    try {
      console.log("API CALL → search:", searchValue, "filter:", filter);

      const data = await getVehiclesList({
        page,
        search: searchValue,
        page_size: pageSize,
        filter: filter   // 👈 PASS TO API
      });

      setVehicles(data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleFilter = (type) => {
    console.log("Filter:", type);
    setFilterType(type);
    fetchVehicles(1, search, type);
  };

  useEffect(() => {
    fetchVehicles(1, filterType);
  }, [filterType]);


  // 🔹 Debounce input
  useEffect(() => {
    const delay = setTimeout(() => {
      setSearch(searchInput);
    }, 400);

    return () => clearTimeout(delay);
  }, [searchInput]);

  // 🔹 Fetch when search changes
  useEffect(() => {
    setCurrentPage(1);
    fetchVehicles(1, search);
  }, [search]);

  // 🔹 Pagination
  useEffect(() => {
    fetchVehicles(currentPage, search);
  }, [currentPage, pageSize]);

  // 🔹 Suggestions
  useEffect(() => {
    const fetchSuggestions = async () => {
      if (!search || search.trim() === "") {
        setSuggestions([]);
        setShowDropdown(false);
        return;
      }

      try {
        const res = await getVehiclesList({
          page: 1,
          search,
          page_size: 5,
        });

        setSuggestions(res.vehicles);
        setShowDropdown(true);
      } catch (error) {
        console.error(error);
      }
    };

    fetchSuggestions();
  }, [search]);

  // 🔹 Select suggestion
  const handleSelect = (vehicle) => {
    const value = `${vehicle.make} ${vehicle.model}`;
    setSearchInput(value);
    setSearch(value);
    setShowDropdown(false);
  };

  // 🔹 Pagination click
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleVehicleClick = async (e) => {
    // setShowLoader(true);
    e.preventDefault();
    try {
      history.push(Routes.AddVehicle.path);
    }
    catch (error) {
      console.log("Team Vehicle Navigation Error:", error);
    } finally {
      // setShowLoader(false);
    } 
  };
  return (
    <>
      {/* <Preloader show={showLoader} /> */}
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-md-0">
          <h4>My Vehicles</h4>
          <p className="mb-0">This is your Vehicles dashboard.</p>
        </div>
        <div className="btn-toolbar mb-2 mb-md-0">
          <ButtonGroup>
            <Button variant="outline-primary" size="sm">Upload</Button>
            <Button variant="outline-primary" size="sm">Sample</Button>
          </ButtonGroup>
        </div>
      </div>

      {/* <div className="table-settings mb-4">
        <Row className="justify-content-between align-items-center">
          <Col xs={4} md={6} lg={3} xl={4}>
            <InputGroup>
              <InputGroup.Text>
                <FontAwesomeIcon icon={faSearch} />
              </InputGroup.Text>
              <Form.Control
                type="text" placeholder="Search Vehicles.."
                // type="text"
                className="form-control"
                // placeholder="Search vehicle..."
                value={searchInput}
                onChange={(e) => {
                  console.log("Typing:", e.target.value);
                  setSearchInput(e.target.value);
                }}
                onFocus={() => setShowDropdown(true)}
              />
            </InputGroup>
          </Col>
          <Col xs={8} md={6} xl={5} className="ps-md-0 text-end">
            <Button variant="secondary" className="text-dark me-3" onClick={handleVehicleClick}>
              <FontAwesomeIcon icon={faPlus} className="d-none d-sm-inline ms-1" />  Add Vehicles </Button>
          </Col>
        </Row>
      </div> */}
      <div className="table-settings mb-4">

        {/* 🔍 Search + Button Row */}
        <Row className="justify-content-between align-items-center mb-3">
          <Col xs={4} md={6} lg={3} xl={4}>
            <InputGroup>
              <InputGroup.Text>
                <FontAwesomeIcon icon={faSearch} />
              </InputGroup.Text>
              <Form.Control
                type="text"
                placeholder="Search Vehicles.."
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                onFocus={() => setShowDropdown(true)}
              />
            </InputGroup>
          </Col>

          <Col xs={8} md={6} xl={5} className="ps-md-0 text-end">
            <Button variant="secondary" className="text-dark me-3" onClick={handleVehicleClick}>
              <FontAwesomeIcon icon={faPlus} className="d-none d-sm-inline ms-1" />
              Add Vehicles
            </Button>
          </Col>
        </Row>

        {/* 🔥 Stats Boxes */}
        <Row className="g-3">

          {/* Total Vehicles */}
          <Col xs={12} md={4}>
            <Card
              className="shadow-sm text-center p-3 cursor-pointer"
              style={{ cursor: "pointer" }}
              onClick={() => handleFilter("ALL")}
            >
              <h6 className="text-muted mb-1">Total Vehicles</h6>
              {/* <h4 className="fw-bold">{totalVehicles}</h4> */}
            </Card>
          </Col>

          <Col xs={12} md={4}>
            <Card
              className="shadow-sm text-center p-3"
              style={{ cursor: "pointer" }}
              onClick={() => handleFilter("THIRD_PARTY")}
            >
              <h6 className="text-muted mb-1">Third Party</h6>
              {/* <h4 className="fw-bold">{thirdPartyCount}</h4> */}
            </Card>
          </Col>

          <Col xs={12} md={4}>
            <Card
              className="shadow-sm text-center p-3"
              style={{ cursor: "pointer" }}
              onClick={() => handleFilter("BLOCKED")}
            >
              <h6 className="text-muted mb-1">Inactive</h6>
              {/* <h4 className="fw-bold text-danger">{blockedCount}</h4> */}
            </Card>
          </Col>

        </Row>

      </div>
      

      {/* <TmsPopup show={showDriverAddWindow}
        handleClose={() => setShowDriverAddWindow(false)}
        title="Add Driver"
        onSave={() => {
          console.log("Save clicked");
          setShowDriverAddWindow(false);
        }}>
        <DriverAddFrom />
      </TmsPopup> */}
      <VehiclesTable
        VehiclesResponse={vehicles}
        onPageChange={(page) => fetchVehicles(page, search, filterType)}
        currentPage={currentPage}
        filterType={filterType}
        setFilterType={setFilterType}
      />
    </>
  );
};
